import {BaseContainerModel} from '../../base-container.model';
import {bl_crm_membership_hdr_RowClass} from '../../../dbschema';

export class MembershipCardHeaderContainerModel extends BaseContainerModel {
  bl_crm_membership_hdr: bl_crm_membership_hdr_RowClass = new bl_crm_membership_hdr_RowClass();
}
